export interface PlatformThemeColors {
  background: string;
  surface: string;
  surface2: string;
  surface3: string;
  border: string;
  text: string;
  textMuted: string;
  textDim: string;
  accentPrimary: string;
  accentSecondary: string;
  accentHover: string;
  headerBackground: string;
  sidebarBackground: string;
  success: string;
  warning: string;
  error: string;
}

export interface PlatformThemeGradients {
  primary: string;
  secondary: string;
  background: string;
  banner: string;
  avatar: string;
}

export interface PlatformTheme {
  _id?: string;
  name: string;
  description?: string;
  colors: PlatformThemeColors;
  gradients: PlatformThemeGradients;
  /** Free-form CSS variable overrides, mirroring messenger's ChatTheme.cssVariables. Recognized
   * keys:
   *   platform-effect: 'glass' | 'glow' — omitted/absent means a plain "classic" theme
   *   platform-glass-alpha: '0'-'1' (default 0.55) — surface translucency for glass themes
   *   platform-glass-blur: e.g. '18px' (default) — backdrop-filter blur radius for glass themes
   *   platform-glow-primary / platform-glow-accent: full box-shadow value overrides for glow
   *     themes (auto-generated from accentPrimary if omitted) */
  cssVariables?: Record<string, string>;
}

export type PlatformThemeEffect = 'classic' | 'glass' | 'glow';

export function getThemeEffectCategory(theme: PlatformTheme): PlatformThemeEffect {
  const effect = theme.cssVariables?.['platform-effect'];
  return effect === 'glass' || effect === 'glow' ? effect : 'classic';
}

export interface ThemePreference {
  kind: 'builtin' | 'custom';
  builtinName?: string;
  themeId?: string;
}

export type PlatformId = 'tohear' | 'platzview' | 'messenger' | 'dating' | 'greetings' | 'generic';
